export default "__VITE_ASSET__43df6d63__"